// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__LfVP_","root_withMargin":"Divider_root_withMargin__yUNkZ","root_solid":"Divider_root_solid__p8DHV","root_dashed":"Divider_root_dashed__BD3nt"};